module.exports = __webpack_public_path__ + "static/media/new.642714b9.png";